import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import { EndSellerManagementPage } from './pages';
import { EndSellerNetwork } from './end-seller-network.setup';

export const EndSellerNetworkModule: ProductLinePermission = {
  id: EndSellerNetwork.id,
  title: 'PAGE.END_SELLER_NETWORK.TITLE',
  path: EndSellerNetwork.path,
  pages: [EndSellerManagementPage],
  showInSidebar: true,
  iconClass: 'fal fa-network-wired',
};
